import React from 'react';
import { motion } from 'framer-motion';
export function TransitionBlock() {
  return <section className="py-14 px-6 bg-white" data-id="element-454">
      <div className="max-w-4xl mx-auto" data-id="element-455">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-6 text-center" data-id="element-456">
          <p className="text-lg md:text-xl text-terracotta font-medium italic max-w-3xl mx-auto" data-id="element-457">
            Y antes de mostrarte el contenido de cada bono que te ofrezco,
            déjame decirte algo importante…
          </p>
          <p className="text-lg text-navy/80 leading-relaxed max-w-3xl mx-auto" data-id="element-458">
            Cuando una persona está agotada, leer un libro no siempre es
            suficiente. Por eso, además del libro, recibirás{' '}
            <span className="font-semibold text-navy" data-id="element-459">
              5 bonos de implementación inmediata
            </span>{' '}
            que te ayudarán a aplicar lo que aprendes sin sentirte solo(a) ni
            abrumado(a).
          </p>
          <p className="text-lg text-navy font-medium leading-relaxed max-w-3xl mx-auto" data-id="element-460">
            Y para que tengas claridad total, aquí te muestro el valor
            individual de cada bono…
          </p>
        </motion.div>
      </div>
    </section>;
}